"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Declined = function Declined() {
  return _react2.default.createElement(
    "g",
    { id: "declined" },
    _react2.default.createElement("path", {
      d: "M250,0 C112,0 0,112 0,250 C0,388 112,500 250,500 C388,500 500,388 500,250 C500,112 388,0 250,0 Z M250,450 C196.951823,450.015922 146.071789,428.949666 108.561061,391.438939 C71.0503335,353.928211 49.9840784,303.048177 50,250 C49.910493,205.577909 64.7948765,162.422004 92.25,127.5 L372.5,407.75 C337.577996,435.205124 294.422091,450.089507 250,450 Z M407.75,372.5 L127.5,92.25 C162.422004,64.7948765 205.577909,49.910493 250,50 C303.048177,49.9840784 353.928211,71.0503335 391.438939,108.561061 C428.949666,146.071789 450.015922,196.951823 450,250 C450.089507,294.422091 435.205124,337.577996 407.75,372.5 Z",
      id: "Shape"
    })
  );
};

exports.default = Declined;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/Declined.js
// module id = 2938
// module chunks = 4